/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Guild } from './Guild';
import {
    GuildFromJSON,
    GuildFromJSONTyped,
    GuildToJSON,
    GuildToJSONTyped,
} from './Guild';
import type { GuildQuest } from './GuildQuest';
import {
    GuildQuestFromJSON,
    GuildQuestFromJSONTyped,
    GuildQuestToJSON,
    GuildQuestToJSONTyped,
} from './GuildQuest';

/**
 * 
 * @export
 * @interface GetGuildProgressResponse
 */
export interface GetGuildProgressResponse {
    /**
     * 
     * @type {Guild}
     * @memberof GetGuildProgressResponse
     */
    guild: Guild;
    /**
     * 
     * @type {boolean}
     * @memberof GetGuildProgressResponse
     */
    isUserInGuild: boolean;
    /**
     * Has user minted the NFT before?
     * @type {boolean}
     * @memberof GetGuildProgressResponse
     */
    hasUserMintedBadge: boolean;
    /**
     * Date when the badge was minted
     * @type {number}
     * @memberof GetGuildProgressResponse
     */
    mintBadgeDate?: number;
    /**
     * Does the user have NftOwnership of it
     * @type {boolean}
     * @memberof GetGuildProgressResponse
     */
    doesUserHaveBadge: boolean;
    /**
     * Are all guild qualifier quests completed?
     * @type {boolean}
     * @memberof GetGuildProgressResponse
     */
    isGuildQualifierQuestsCompleted: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetGuildProgressResponse
     */
    members: Array<string>;
    /**
     * 
     * @type {Array<GuildQuest>}
     * @memberof GetGuildProgressResponse
     */
    quests: Array<GuildQuest>;
    /**
     * 
     * @type {string}
     * @memberof GetGuildProgressResponse
     */
    badgeImageUrl?: string;
}

/**
 * Check if a given object implements the GetGuildProgressResponse interface.
 */
export function instanceOfGetGuildProgressResponse(value: object): value is GetGuildProgressResponse {
    if (!('guild' in value) || value['guild'] === undefined) return false;
    if (!('isUserInGuild' in value) || value['isUserInGuild'] === undefined) return false;
    if (!('hasUserMintedBadge' in value) || value['hasUserMintedBadge'] === undefined) return false;
    if (!('doesUserHaveBadge' in value) || value['doesUserHaveBadge'] === undefined) return false;
    if (!('isGuildQualifierQuestsCompleted' in value) || value['isGuildQualifierQuestsCompleted'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    if (!('quests' in value) || value['quests'] === undefined) return false;
    return true;
}

export function GetGuildProgressResponseFromJSON(json: any): GetGuildProgressResponse {
    return GetGuildProgressResponseFromJSONTyped(json, false);
}

export function GetGuildProgressResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGuildProgressResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'guild': GuildFromJSON(json['guild']),
        'isUserInGuild': json['isUserInGuild'],
        'hasUserMintedBadge': json['hasUserMintedBadge'],
        'mintBadgeDate': json['mintBadgeDate'] == null ? undefined : json['mintBadgeDate'],
        'doesUserHaveBadge': json['doesUserHaveBadge'],
        'isGuildQualifierQuestsCompleted': json['isGuildQualifierQuestsCompleted'],
        'members': json['members'],
        'quests': ((json['quests'] as Array<any>).map(GuildQuestFromJSON)),
        'badgeImageUrl': json['badgeImageUrl'] == null ? undefined : json['badgeImageUrl'],
    };
}

export function GetGuildProgressResponseToJSON(json: any): GetGuildProgressResponse {
    return GetGuildProgressResponseToJSONTyped(json, false);
}

export function GetGuildProgressResponseToJSONTyped(value?: GetGuildProgressResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'guild': GuildToJSON(value['guild']),
        'isUserInGuild': value['isUserInGuild'],
        'hasUserMintedBadge': value['hasUserMintedBadge'],
        'mintBadgeDate': value['mintBadgeDate'],
        'doesUserHaveBadge': value['doesUserHaveBadge'],
        'isGuildQualifierQuestsCompleted': value['isGuildQualifierQuestsCompleted'],
        'members': value['members'],
        'quests': ((value['quests'] as Array<any>).map(GuildQuestToJSON)),
        'badgeImageUrl': value['badgeImageUrl'],
    };
}

